import { Alert, Button } from "@mui/material";
import React, { useContext, useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ACTION_TYPES } from "../services/actions/actions";
import { useEffect } from "react";
import Auth from "../services/context/store";
import LoadingIcon from "../components/LoadingIcon";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [state, dispatch] = useContext(Auth);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get("status");
  const verifyMessage = queryParams.get("message");

  const returnUrl = useLocation();
  const pathName = returnUrl.search;
  const lengthOfUrl = pathName.length;

  const handleEmail = (e) => {
    const userEmail = e.target.value;
    setEmail(userEmail);
  };

  const handlePassword = (e) => {
    const userPassword = e.target.value;
    setPassword(userPassword);
  };

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const response = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        password,
      }),
    });

    const data = await response.json();

    if (data.User) {
      if (returnUrl.search.length <= 2 || status) {
        navigate("/");
      } else {
        navigate(`${pathName.substring(1, lengthOfUrl)}`);
      }
      localStorage.setItem("token", data.token);
      dispatch({ type: ACTION_TYPES.LOGIN, payload: { user: data.user } });
    } else {
      setError(data.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (state.loggedIn) {
      navigate("/");
    }
  }, [navigate, state.loggedIn]);

  return (
    <div className="waves">
      <div className="mx-auto md:w-1/3 w-full absolute">
        <div className="d-flex mb-10 mt-10 p-2">
          <div
            className="w-full bg-white rounded-sm p-3"
            style={{ textAlign: "center", height: "550px" }}
          >
            {verifyMessage && (
              <div style={{ color: status === "true" ? "green" : "red" }}>
                {verifyMessage}
              </div>
            )}
            <div>
              <Form className={"px-4 py-2"} onSubmit={login}>
                <h6 className="mb-5 text-black text-center text-3xl font-semibold">
                  Secure Login
                </h6>
                <FloatingLabel
                  controlId="floatingInput"
                  label="Email address"
                  className="mb-4"
                >
                  <Form.Control
                    onChange={handleEmail}
                    type="email"
                    placeholder="name@example.com"
                    required
                    disabled={loading}
                  />
                </FloatingLabel>
                <FloatingLabel
                  controlId="floatingPassword"
                  label="Password"
                  className="mb-4"
                >
                  <Form.Control
                    onChange={handlePassword}
                    type="password"
                    placeholder="Password"
                    required
                    disabled={loading}
                  />
                </FloatingLabel>
                <div className="d-grid gap-2 my-6">
                  {loading ? (
                    <Button size="large">
                      <LoadingIcon />
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      size="large"
                      className="text-white !bg-black"
                      type="submit"
                    >
                      Sign In
                    </Button>
                  )}
                </div>
              </Form>
            </div>
            <div>
              {/* <div className="mt-8">
              <span className="text-gray-600">Don't have an account? </span>
                <Link
                  to={`/client-register`}
                  className="no-underline text-black"
                >
                  Sign Up
                </Link>
              </div> */}
              <div className="mt-8">
                <span className="text-gray-600">Forgotten your password? </span>
                <Link
                  to={`/reset/password`}
                  className="no-underline text-black"
                >
                  Reset Password
                </Link>
              </div>
              {error && (
                <Alert sx={{ mt: 2 }} severity="error">
                  {error}
                </Alert>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
